@import "../../../styles/base";

.c-badge {
  font-size: $ds-font-size-b3;
  font-weight: 500;
  background: $ds-neutral-100;
  color: $ds-neutral-900;
  padding: 0.125rem 0.5em;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
  letter-spacing: 0.025em;
  vertical-align: bottom;
  text-align: center;
  line-height: 1.25rem;
  white-space: nowrap;

  &--success {
    background: $ds-jade-50;
    color: $ds-jade-900;
  }

  &--info {
    background: $ds-teal-50;
    color: $ds-teal-900;
  }

  &--warning {
    background: $ds-mustard-50;
    color: $ds-mustard-900;
  }

  &--danger {
    background: $ds-coral-50;
    color: $ds-coral-900;
  }

  &--primary {
    background: $ds-violet-100;
    color: $ds-violet-900;
  }

  &--mustard {
    background: $ds-mustard-100;
    color: $ds-mustard-900;
  }

  + .c-badge {
    margin-left: 0.25rem;
  }
}
